<template>
  <div class="container">
    <div v-if="showPage">
      <div class="package-title">
      <div class="flex-row-sc">
        优惠券包
        <span
          v-if="couponPackageList && couponPackageList.length == 1"
          @click="showUseBox = true"
          >{{ couponPackageList[0].package_ttl }}天内有效 | 使用说明
        </span>
        <img v-if="couponPackageList && couponPackageList.length == 1" class="icon" src="../assets/images/icon-warning.png" alt="">
      </div>
      <div class="link" @click="toRecord()">购买记录<span class="icon_arrow_next"></span></div>
    </div>
    <div class="cpackage-list">
      <div class="item" v-for="(item, index) in recordList" :key="index" style="align-items: center">
        <div>
          <div class="fs-28 fw-bold">您有订单未完成支付</div>
          <div class="fs-24" style="margin-top: .16rem">{{item.promotion_name}}-{{item.coupon_num}}张{{item.coupon_amount}}元优惠券</div>
        </div>
        <div class="btn-buy" style="margin-top: 0" @click="toRecord()">待支付</div>
      </div>
      <div class="item" v-for="(item, index) in couponPackageList" v-bind:key="index">
        <div style="display: flex;">
          <div class="img">
            <div class="c-tit">{{ item.package_coupon_title }}</div>
            <div class="c-price">
              <span>{{ item.package_unit_price }}</span
              >元x<span>{{ item.package_unit_num }}</span
              >张
            </div>
            <div class="c-desc">{{ item.package_coupon_desc }}</div>
          </div>
          <div style="width: 3.2rem;">
            <div class="name">{{ item.package_name }}</div>
            <div>
              {{ item.package_status === 0 ? item.package_error : item.package_shop_desc }}
              <span
                  style="
                    color: #5cb9ff;
                    margin-left: 0.1rem;
                    text-decoration: underline;
                  "
                  @click="viewShops(item)"
                  >去查看</span
                >
            </div>
            <div class="price">
              ¥<span>{{ item.package_selling_price }}</span>
            </div>
          </div>
        </div>
        <div
          class="btn-buy"
          :class="item.package_status === 0 ? 'disabled' : ''"
          @click="
            openShowPay(item)
          "
        >
          立即购买
        </div>
      </div>
    </div>
    <div class="shop-list" v-if="couponPackageList && couponPackageList.length == 1">
      <div class="package-title">以下为红包可用商家</div>
      <div class="goods-list shop" v-if="packageShop.length > 0">
        <ul class="goods">
          <li v-for="(item, index) in packageShop" v-bind:key="index">
            <div class="goods-box">
              <a>
                <div
                  class="goods-img"
                  @click="toGoodsList(item.id, item.shop_name)"
                >
                  <div class="lazy goodimg">
                    <img :src="item.pic" alt="">
                  </div>
                  <div
                    class="mark"
                    v-if="item.is_mark == 1"
                    :style="{ backgroundColor: item.mark_color }"
                  >
                    {{ item.mark }}
                  </div>
                </div>
                <div
                  class="goods-des"
                  @click="toGoodsList(item.id, item.shop_name)"
                >
                  <div class="name ellipse">{{ item.shop_name }}</div>
                  <div class="comment" style="margin-top: 0.03rem">
                    <CommentStars :qualityCode="item.score"></CommentStars>
                    <span>{{ item.score }}</span>
                    <span style="color: #e3e3e3">|</span>
                    <span>月售 {{ item.sales_append }}单</span>
                  </div>
                  <div class="flex-row-bc">
                    <div class="threshold">
                      <span style="margin-right: 0.1rem"
                        >起送 ￥{{ item.threshold_amount }}</span
                      >
                      <span style="color: #e3e3e3">|</span>
                      <div
                        v-if="
                          item.new_delivery_fee || item.new_delivery_fee === 0
                        "
                      >
                        <span style="margin-right: 0"
                          >配送￥{{ item.new_delivery_fee }}</span
                        >
                        <span v-if="item.is_many_delivery == 1">起</span>
                        <span
                          style="
                            color: #999;
                            text-decoration: line-through;
                            margin-right: 0;
                          "
                          >￥{{ item.delivery_fee }}</span
                        >
                      </div>
                      <div v-else>
                        <span style="margin-right: 0"
                          >配送￥{{ item.delivery_fee }}</span
                        >
                        <span v-if="item.is_many_delivery == 1">起</span>
                      </div>
                      <span v-if="item.delivery_type == 1">(商家配送)</span>
                    </div>
                    <div v-if="item.dinnerDuration">{{item.dinnerDuration}}</div>
                  </div>

                </div>
                <!--店铺副标题、准时达-->
                <div class="flex-row-bc">
                  <div class="vice_title" v-if="item.vice_title">{{ item.vice_title }}</div>
                  <div class="punctual-arrive" v-if="item.zsd">{{ item.zsd }}</div>
                </div>
                <!--促销活动-->
                <div
                  class="promotion_reduce"
                  v-if="
                    item.promotion_reduce && item.promotion_reduce.reduce_info
                  "
                >
                  <span
                    v-for="(item2, index2) of item.promotion_reduce.reduce_info"
                    :key="index2"
                    class="promotion_reduce-type border"
                    >{{ item2.meet_price }}减{{ item2.cut_price }}</span
                  >
                </div>
                <!--店铺优惠券-->
                <div class="promotion-and-coupon">
                  <div class="promotion" v-if="item.promotion_list && item.promotion_list.length > 0">
                    <img class="icon" v-for="pro in item.promotion_list" :src="pro.icon_url" width="100%" >
                  </div>
                  <div class="package" v-if="item.promotion_package && item.promotion_package.length > 0">
                    <span v-for="(proPackage,index5) in item.promotion_package" :key="index5">{{proPackage.package_desc}}</span>
                  </div>
                  <div class="coupon" v-if="item.coupon_list && item.coupon_list.length > 0">
                    <span class="desc" v-for="(coupon,index6) in item.coupon_list" :key="index6">{{ coupon.couponDes }}</span>
                    <span class="get">领券</span>
                  </div>
                </div>
                <span
                  v-if="item.is_open == 1 && item.is_book == 0"
                  class="shop-status"
                  >营业中</span
                >
                <span
                  v-else-if="item.is_open == 1 && item.is_book == 1"
                  class="shop-status can-reserve"
                  >可预订</span
                >
                <span class="shop-status close" v-else>已打烊</span>
                <div class="shop-type-box">
                  <span
                    class="shop-type border"
                    v-if="item.is_self_take_new == 1"
                    >自提</span
                  >
                  <span class="shop-type border" v-if="item.is_take_out == 1"
                    >外送</span
                  >
                  <span
                    class="shop-type eat-in border"
                    v-if="item.is_eat_in == 1"
                    >堂食</span
                  >
                </div>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 确认购买弹框 -->
    <div
      class="mask over"
      v-if="showPayBox"
      @click="showPayBox = false"
      @touchmove.prevent
    ></div>
    <div class="pay-box" v-if="showPayBox">
      <div class="title">确认购买</div>
      <div class="cpackage-list">
        <div class="item">
          <div style="display: flex; align-items: center">
            <div class="img">
              <div class="c-tit">{{ packageDetail.package_coupon_title }}</div>
              <div class="c-price">
                <span>{{ packageDetail.package_unit_price }}</span
                >元x<span>{{ packageDetail.package_unit_num }}</span
                >张
              </div>
              <div class="c-desc">{{ packageDetail.package_coupon_desc }}</div>
            </div>
            <div>
              <div class="name">{{ packageDetail.package_name }}</div>
              <div style="color: #ff4a61; padding-bottom: 0.16rem">
                有效期至：{{ packageDetail.package_sendTime }}
                <span class="leave-day">剩余{{ packageDetail.package_ttl }}天</span>
              </div>
              <div>
                {{ packageDetail.package_shop_desc
                }}<span
                  style="
                    color: #5cb9ff;
                    margin-left: 0.1rem;
                    text-decoration: underline;
                  "
                  @click="viewShops(packageDetail)"
                  >去查看</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="use-tips">
        <div class="tit">使用说明</div>
        <div v-html="packageDetail.package_rule"></div>
      </div>
      <div class="to-pay" @click="toPay()">
        ¥{{ packageDetail.package_selling_price }}立即支付
      </div>
    </div>
    <!-- 使用说明弹框 -->
    <div
      class="mask over"
      v-if="showUseBox"
      @click="showUseBox = false"
      @touchmove.prevent
    ></div>
    <div class="pay-box" v-if="showUseBox">
      <div class="use-tips">
        <div class="tit">使用说明</div>
        <div v-html="packageDetail.package_rule"></div>
      </div>
    </div>
    </div>
    <div class="nothing" v-else>
      <img src="../assets/images/empty-01.png" />
      暂时没有可购的券包~
    </div>
  </div>
</template>
<script>
import { actions } from "../store/actions";
import CommentStars from "../components/CommentStars";
export default {
  name: "CouponPackage",
  components: {
    CommentStars,
  },
  data() {
    return {
      couponPackageList: [],
      packageDetail: {},
      packageShop: [],
      showPayBox: false,
      isCanSubmit: true,
      showUseBox: false,
      recordList: [],
      showPage: true
    };
  },
  created() {
    let uid = this.$store.state.wxUid
    if (!uid) { // 如果没有登录信息先跳转登录页
      this.$utils.toLogin(this);
    }else{
      this.getCouponPackageList();
      this.getRecordList();
    }
  },
  methods: {
    getCouponPackageList() {
      let _this = this;
      let params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        source: 0
      };
      actions.postPackageList(_this, params, (data) => {
        if (data && data.length > 0) {
          for (let v of data) {
            if (v.package_rule) {
              v.package_rule = v.package_rule.replace(
                /(\n|\r|\r\n|↵)/g,
                "<br/>"
              );
            }
            if(_this.$route.query && _this.$route.query.id){
              let id = _this.$route.query.id;
              if(v.package_id == id){
                _this.packageDetail = v;
                _this.getPackageShop(v.package_shop);
                if(v.package_status === 1){
                  _this.showPayBox = true;
                }
              }
            }else{
              _this.packageDetail = data[0];
              _this.getPackageShop(data[0].package_shop);
            }
          }
          _this.couponPackageList = data;
          // 曝光埋点
          let logDetails = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_coupon_bag_index',
            createTime: new Date().getTime(),
            firstValue: _this.$store.state.schoolInfo.schoolId
          }]
          _this.addLog(logDetails);
        }else{
          _this.showPage = false;
        }
      },() => {
        _this.showPage = false;
      });
    },
    getPackageShop(shops) {
      let _this = this;
      let params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        page: 1,
        pageSize: 1000,
        shops: shops,
      };
      actions.postPackageShop(_this, params, (data) => {
        if (data && data.length > 0) {
          for (let shop of data) {
            if (shop.promotion_list && shop.promotion_list.length > 0) {
              shop.promotion_list = _.uniqBy(
                shop.promotion_list,
                (item) => item.promotion_type
              );
            }
          }
          _this.packageShop = data;
        }
      });
    },
    getRecordList() {
      let _this = this;
      let params = {
        order_status: 0,
        page: 1,
        page_size: 1000
      };
      actions.postPackagePurchaseRecord(_this, params, (data) => {
        if(data && data.list && data.list.length > 0){
          this.recordList = data.list;
        }
      });
    },
    toPay() {
      let _this = this;
      if (!_this.isCanSubmit) {
        return;
      }
      let params = {
        schoolId: _this.$store.state.schoolInfo.schoolId,
        schoolName: _this.$store.state.schoolInfo.schoolName,
        couponPackageId: _this.packageDetail.package_id,
        couponPackageAmount: _this.packageDetail.package_selling_price,
        orderType: 8,
        couponPackageType: _this.packageDetail.package_type,
        goods: [
          {
            goodsName: _this.packageDetail.package_name,
            price: _this.packageDetail.package_selling_price,
            number: 1,
          },
        ],
      };
      _this.isCanSubmit = false;
      actions.postOrderCreate(
        _this,
        params,
        (data) => {
          if (data.status === 0) {
            window.localStorage.setItem("order-type", 8);
            window.localStorage.setItem("orderCode", data.orderId);
            _this.showPayBox = false;
            _this.$router.push({ name: "Payment" });
          }
        },
        (data) => {
          _this.$messagebox.alert(data.data.message, "");
          _this.isCanSubmit = true;
        }
      );
    },
    openShowPay(item) {
      if(item.package_status === 1){
        this.showPayBox = true;
        this.packageDetail = item;
        // 点击埋点
        let logDetails = [{
          uid: this.$store.state.wxUid,
          code: 'click_coupon_bag_index',
          createTime: new Date().getTime(),
          refId: item.package_id,
          firstValue: this.$store.state.schoolInfo.schoolId
        }]
        this.addLog(logDetails);
      }
    },
    viewShops(item) {
      this.showPayBox = false;
      this.$router.push({
        name: "CouponPackageShopList",
        query: { shops: item.package_shop.join(',') }
      });
    },
    toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: "orderDishes",
      };
      _this.$store.commit("changeState", obj);
      _this.$router.push({ name: "GoodsList" });
    },
    toRecord() {
      this.$router.push({
        name: "CouponPackageRecord"
      });
    },
    // 统计埋点
    addLog(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    }
  },
}
</script>
<style scoped>
.container {
  padding: 0.32rem 0.24rem;
}
.package-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.32rem;
  font-weight: bold;
}
.package-title span {
  padding-left: 0.16rem;
  font-size: 0.2rem;
  color: #666;
  font-weight: normal;
}
.package-title .link {
  font-size: 0.2rem;
  font-weight: normal;
  color: #999;
}
.package-title .icon{
  width: .16rem;
  height: .16rem;
  margin-left: .08rem;
}
.pay-box {
  position: fixed;
  width: 100%;
  /* height: 6rem; */
  left: 0;
  bottom: 0;
  padding: 0.32rem;
  padding-bottom: 0.68rem;
  animation: mymove 0.5s;
  -webkit-animation: mymove 0.5s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  background-color: #ffffff;
  border-radius: 0.24rem 0.24rem 0px 0px;
  z-index: 25;
}
.pay-box .title {
  font-size: 0.36rem;
  font-weight: bold;
  text-align: center;
}
.pay-box .cpackage-list {
  margin-bottom: 0;
  padding: .24rem 0;
}
.pay-box .cpackage-list .item {
  align-items: center;
}
.pay-box .to-pay {
  width: 6.86rem;
  height: 0.8rem;
  line-height: 0.8rem;
  background: linear-gradient(135deg, #ffec00 0%, #fed400 100%);
  border-radius: 0.08rem;
  text-align: center;
  font-size: 0.24rem;
  font-weight: bold;
  margin-top: 0.32rem;
}
.pay-box .use-tips {
  font-size: 0.24rem;
  color: #666;
  line-height: 0.36rem;
}
.pay-box .use-tips .tit {
  font-size: 0.28rem;
  font-weight: bold;
  padding-bottom: 0.24rem;
}
.goods-list {
  margin-top: 0.24rem;
}
.goods-box .goods-img {
  position: relative;
}
.goods-box .goods-img .mark {
  position: absolute;
  padding: 0 0.06rem;
  height: 0.3rem;
  top: 0;
  left: 0;
  line-height: 0.3rem;
  background-color: #fff100;
  border-radius: 0.04rem;
  font-size: 0.22rem;
  color: #fff;
  text-align: center;
}
.package-title .icon_arrow_next {
  padding-left: 0.25rem;
  background-position: center center;
  background-size: .1rem auto;
}
.nothing{
  display: flex;
  padding: 2rem 0;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
}
.nothing img{
  width: 2.5rem;
  padding-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// CouponPackage.vue?5a1b86e0